export const APP_STORE_URL = 'https://apps.apple.com/in/app/al-ittihad-tickets/id6477918526';
export const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.webook.ittihad.android';
export const HUAWEI_STORE_URL = '';
